import axios from '@/components/mainConfig/axiosConfig' 
 import router from './../../router'
 import Vue from 'vue'
//  import router from './router'
// const routerConfig=router.create({
   
// })
router.afterEach((to, from, next) => {
  let url = to.path+to.query.htmlpath
  if(to.path=='/communications'||to.path=='/text'||to.path=='/news'||to.path=='/InfoFour'||to.path=='/FourCommunication'){
    setPVUV(url, to.meta.title,to.path)
   }
})
//hasToken和setPVUV方法都在common.js中，导出对象名是comFun
let config = {headers: { "Content-Type": "application/json" }};    

//统计页面PV和UV
const setPVUV = (url, title,path) => {
const formData = new FormData()
formData.append("path",path)
formData.append("url",url)
formData.append("webName",title)
if(localStorage.getItem('user')!=null){
  formData.append("openId",JSON.parse(localStorage.getItem('user')).userid)
  Vue.prototype.$user=JSON.parse(localStorage.getItem('user'))
}else{
  Vue.prototype.$user=null
}
axios.post("/user/getPVandUV",formData,config)
.then((resp) => {
  if (resp.data.status == 1) {
  
  } 
})
.catch((err) => {
  // console.log(err)
  Message.error("出错");
});
}
export default router


// WEBPACK FOOTER //
// ./src/components/mainConfig/routerConfig.js